import PropTypes from 'prop-types';
import { Tracking } from 'components/seo/tracking/tracker';
import { useEffect } from 'react';

const SeoTracking = ({ templateName, pageCode }) => {
    useEffect(() => {
        if (!window) {
            return;
        }

        window.__GLOBAL_CECA = window.__GLOBAL_CECA || {};
        window.defer_until(function () {
            return window.Cookies !== undefined;
        }, function () {
            Tracking({
                button_selector: '.button-to-track',
                default_utms: { utm_medium: 'organic', utm_campaign: templateName }
            });
        });

        try {
            fetch('https://deer.ceca.co/api/v1/page-request/', {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ page_code: pageCode })
            }).catch(() => {});
        } catch (err) {
            // pass
        }
    }, [templateName, pageCode]);

    return null;
};

SeoTracking.propTypes = {
    templateName: PropTypes.string
};

export default SeoTracking;
